import * as roles from 'src/api/roles'
import router from 'src/router'
import {
  GET_ALL_ROLES,
  GET_ROLE
} from 'src/store/mutation-types'

const getAllRoles = ({commit, dispatch}, params = {}) => {
  dispatch('toggleLoadding', true, {root: true})
  roles.getAllRoles(params).then(response => {
    if (response.code === 200) {
      dispatch('toggleLoadding', false, {root: true})
      commit(GET_ALL_ROLES, response.data)
    } else {
      dispatch('toggleLoadding', false, {root: true})
      commit(GET_ALL_ROLES, [])
    }
  })
}

const getRole = ({commit, dispatch}, configs) => {
  dispatch('toggleLoadding', true, {root: true})
  roles.getRole(configs.id, configs.params).then(response => {
    switch (response.code) {
      case 200:
        dispatch('toggleLoadding', false, {root: true})
        commit(GET_ROLE, response.data)
        break
      case 404:
        dispatch('toggleLoadding', false, {root: true})
        dispatch('showNotify', {
          title: 'Không tìm thấy tài nguyên',
          body: 'Role không tồn tại trên hệ thống',
          type: 'warning'
        }, {root: true})
        router.push({name: 'role'})
        break
      default:
        dispatch('toggleLoadding', false, {root: true})
    }
  })
}

const setRole = ({commit}, role) => {
  commit(GET_ROLE, role)
}

export default {
  getAllRoles,
  getRole,
  setRole
}



// WEBPACK FOOTER //
// ./src/components/role/store/actions.js